import { createActionGroup, props } from '@ngrx/store';
import { CategoryWifiProfileConfiguration } from '@rocksoft/settings-sdk';
import { ErrorModel } from '@rocksoft/shared';
import { Category } from '../router/category';

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryWifiProfilePresetConfigurationApiActions = createActionGroup({
  source: 'Category wifi profile preset configuration API',
  events: {
    'Category wifi profile preset configurations updated error': props<{
      category: Category;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryWifiProfilePresetConfigurationViewActions = createActionGroup({
  source: 'Category wifi profile preset configuration view',
  events: {
    'Wifi profile preset configurations updated': props<{
      category: Category;
      updatedWifiProfilesLinkedToCategory: CategoryWifiProfileConfiguration[];
    }>(),
  },
});
